<template>
    <tab-users :company_id="company_id" ref="UsersTab" />
</template>

<script>
import TabUsers from '@/components/tabs/Users.vue';

export default {
    components: {
        TabUsers,
    },
    props: {
        company_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        reloadTable() {
            this.$refs.UsersTab.reloadTable();
        },
    },
};
</script>
